// Generated by CoffeeScript 1.11.1
(function() {
  module.exports = {
    parseRaw: function() {
      return this.channelData.set(this.file.read(this.length));
    }
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/image_formats/raw.js
// module id = 44
// module chunks = 0